import { render, staticRenderFns } from "./goodsAudit.vue?vue&type=template&id=662fa123&scoped=true"
import script from "./goodsAudit.vue?vue&type=script&lang=js"
export * from "./goodsAudit.vue?vue&type=script&lang=js"
import style0 from "./goodsAudit.vue?vue&type=style&index=0&id=662fa123&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662fa123",
  null
  
)

export default component.exports